import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import Constants from "@constants/Constants";

const {
  ROUTES_BROWSER_TITLE: { USE_CASE_INSIGHTS },
  ROUTES: { DETAIL, USE_CASES, CASE_EXAMPLES },
} = Constants;

const PageTitle = ({ title }) => {
  const location = useLocation();
  const { pathname } = useLocation();
  const { usecase } = useSelector((state) => state.usecases);
  const { caseExample } = useSelector((state) => state.caseExamplesDetails);

  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [location, title]);

  useEffect(() => {
    if (usecase?.title && pathname.includes(USE_CASES) && pathname.includes(DETAIL)) {
      document.title = USE_CASE_INSIGHTS + usecase?.title;
    }
  }, [usecase])

   useEffect(() => {
    if (caseExample?.caseStudyTitle && pathname.includes(CASE_EXAMPLES) && pathname.includes(DETAIL)) {
      document.title = USE_CASE_INSIGHTS + caseExample?.caseStudyTitle;
    }
  }, [caseExample])

  return null;
}

export default PageTitle;